import React, { useState } from "react";
const SkillsStarRating = (props) => {
  const updateDotRating = (dotId) => {
    props.updateRating(parseInt(dotId));
  };
  return (
    <div className="rating-bar star-rating-bar">
      <span className="rating-bar star-rating-bar">
        {Array.from({ length: 5 }, (v, i) => {
          let dotId = i + 1;
          return (
            <span
              className={`star rating-point-${dotId} ${dotId <= props.value ? "selected" : ""}`}
              key={`key_${dotId}`}
              onClick={(e) => {
                updateDotRating(dotId);
              }}
            ></span>
          );
        })}
      </span>
    </div>
  );
};
export default SkillsStarRating;
